import * as React from "react";
import { cn } from "@/lib/utils";

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "ghost" | "brass" | "outline";
  size?: "sm" | "md" | "lg";
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant = "primary", size = "md", children, ...props }, ref) => {
    return (
      <button
        ref={ref}
        className={cn(
          "inline-flex items-center justify-center font-medium rounded-full transition-all duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-clay/50 disabled:opacity-50 disabled:pointer-events-none cursor-pointer",
          // Variant styling
          variant === "primary" &&
            "bg-clay hover:bg-clay-deep text-paper shadow-sm active:scale-[0.98]",
          variant === "secondary" &&
            "bg-paper-deep hover:bg-line text-ink active:scale-[0.98]",
          variant === "brass" &&
            "bg-brass hover:bg-brass-deep text-paper shadow-sm active:scale-[0.98]",
          variant === "ghost" &&
            "bg-transparent hover:bg-paper-deep text-ink-soft hover:text-ink",
          variant === "outline" &&
            "border border-line bg-paper/80 hover:bg-paper-deep text-ink",
          // Size
          size === "sm" && "text-xs px-3.5 py-1.5 gap-1.5",
          size === "md" && "text-sm px-5 py-2.5 gap-2",
          size === "lg" && "text-base px-7 py-3.5 gap-2.5 font-semibold",
          className
        )}
        {...props}
      >
        {children}
      </button>
    );
  }
);
Button.displayName = "Button";
